import { getLocaleStore } from '../i18n/locale-controller.js';
import { AudioService, detectTestMute } from './audio-service.js';

let instance: AudioService | undefined;

export function initAudioService(testMute?: boolean): AudioService {
  if (instance) return instance;
  instance = new AudioService({
    getLocale: () => getLocaleStore().locale,
    testMute: testMute ?? detectTestMute(),
  });
  return instance;
}

export function getAudioService(): AudioService {
  if (!instance) return initAudioService();
  return instance;
}

export function _resetAudioServiceForTests(): void {
  instance = undefined;
}
